import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { MappedGuest } from '@features/DynamicPackagesConfigurationWizard/types';

type GuestLabelProps = {
  guest: MappedGuest;
};
export const GuestLabel: FC<GuestLabelProps> = ({ guest }) => {
  const { t } = useTranslations();
  const title = guest.title?.toLocaleLowerCase() as 'mr' | 'mrs' | 'miss' | 'ms';
  return (
    <>
      {title && (
        <>
          {t(`common.${title}`) + ' '}
          {guest.firstName} {guest.lastName}
        </>
      )}
    </>
  );
};
